import type { FillInputProps } from '../fillInput';
import { TextInput } from '../shared/TextInput';
import { numberOf } from '../shared/bounds';

export const TextFieldInput = (props: FillInputProps<string, { multiline?: boolean }>) => {
  const maxLength = numberOf(props.bounds.max);
  return <TextInput {...props} multiline={props.settings.multiline === true} spellCheck maxLength={maxLength} />;
};
